var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.09
  }), /*#__PURE__*/React.createElement("rect", {
    y: 341.91,
    style: {
      fill: "#464655"
    },
    width: 512,
    height: 170.09
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.09,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 171.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M150.03,223.314l7.36,22.068l23.262,0.18c3.012,0.023,4.261,3.867,1.838,5.656l-18.714,13.819   l7.017,22.179c0.908,2.872-2.361,5.247-4.811,3.496l-18.926-13.527l-18.926,13.527c-2.45,1.751-5.72-0.624-4.811-3.496   l7.017-22.179l-18.714-13.819c-2.423-1.789-1.174-5.633,1.838-5.656l23.262-0.18l7.36-22.068   C145.036,220.457,149.077,220.457,150.03,223.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M367.917,223.314l7.36,22.068l23.262,0.18c3.012,0.023,4.261,3.867,1.838,5.656l-18.714,13.819   l7.017,22.179c0.908,2.872-2.361,5.247-4.811,3.496l-18.926-13.527l-18.926,13.527c-2.45,1.751-5.72-0.624-4.811-3.496   l7.017-22.179l-18.714-13.819c-2.423-1.789-1.174-5.633,1.838-5.656l23.262-0.18l7.36-22.068   C362.923,220.457,366.964,220.457,367.917,223.314z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSy);
export default __webpack_public_path__ + "static/media/sy.e5ab1b4b487e7fc05857acc294d390ea.svg";
export { ForwardRef as ReactComponent };